import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Image, Paper, Text, rem } from '@mantine/core';
export const WalletVerify: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    setOpenModal
  } = useModalAction();
  return <Paper mt={20} radius={5} pos="relative" p={{
    base: 12,
    sm: 20
  }} onClick={() => setOpenModal(MODAL.KYC)} bg="var(--input-variant-color)" h={{
    base: 60,
    sm: 80,
    md: 70
  }}>
      <Image pos="absolute" alt="verify-img" src="/assets/wallet/verify.svg" w={{
      base: 100,
      sm: 136,
      lg: 164
    }} h={{
      base: 100,
      sm: 136,
      lg: 160
    }} right={{
      base: rem(0),
      sm: rem(43)
    }} top={{
      base: rem(-20),
      sm: rem(-30),
      md: rem(-40)
    }} />

      <Text fz={{
      base: 10,
      sm: 12
    }} fw={700} tt="uppercase" c="var(--text-prime)">
        {i18n._('Improve your account security')}
      </Text>
      <Text fz={{
      base: 14,
      sm: 18
    }} lh={rem(18)} className={gunterzBold.className}>
        {i18n._('ENABLE 2FA')}
      </Text>
    </Paper>;
};